import StateType from './state.type';

export default {
  loading: false,
  order: {},
} as StateType;
